import React, { useState, useRef, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { PrimaryButton, SecondaryButton } from 'Components/Inputes/CustomButton';
import { Container, Grid, Paper } from '@material-ui/core';
import { useHistory } from 'react-router';
import { LOGOUT } from 'ConstComponents';
import { GetFingerPrint } from 'Components/FingerPrintProcessing';
import { DailyMasterAuthentication as TWOFACTORAUTHENTICATION } from 'Components/Api/OneClickAEPSAPI';
import * as Yup from 'yup';
import { CONSUMER_NUMBER_FONT_SIZE } from 'Config';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { Select as TRANSACTION_REPORT } from 'Components/Api/PaysprintAEPSAPI'
import RechargeIcon from 'Components/SvgButtons/RechargeIcon';
import ReactTable from 'Components/ReactTable/ReactTable';
import Box from '@material-ui/core/Box';
import HOCLoader from 'Components/Loader/HOCLoader';
import {
    PLEASE_PROVIDE_VALID,
    AEPS_OPERATOR_ID,
    AADHARPAY_OPERATOR_ID,
} from 'Components/Helper/Messages';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import usePosition from 'Components/Posistion';
import { FailTransactionResponse } from 'Components/Alert/FailTransactionResponse';
import { ONECLICK } from 'Components/Helper/AEPSProviderName';
import ResetIcon from 'Components/SvgButtons/ResetIcon';

const CustomContainer = HOCLoader(Container);

export const OneClickTwoFactorAuthentication = ({ onDismissCallback }) => {
    const history = useHistory();
    const [loadingOpen, setLoadingOpen] = useState(false);
    const formRef = useRef();
    const classes = commonStyle();
    const [consumerNumberFontSize, setConsumerNumberFontSize] = useState('');
    async function fetchConsumerNumberFontSize() {
        setConsumerNumberFontSize(await CONSUMER_NUMBER_FONT_SIZE());
    }
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [status, setStatus] = useState('PROCESS');
    const [Message, setMessage] = useState('');
    const [isAlertErrorOpen, setIsAlertErrorOpen] = useState(false);
    const [transactions, setTransactions] = useState([]);
    const { latitude, longitude, error } = usePosition();
    const Mobile = localStorage.getItem('MobileNumber');
    const [mainColumns, setMainColumns] = useState([]);

    const aadharNumber = localStorage.getItem('AadharNo');
    const [formObj, setFormObj] = useState({
        AadharNo: aadharNumber,
        MobileNumber: Mobile,
        FingerPrint: '',
        IsAEPS: false,
        Latitude: latitude,
        Longitude: longitude
    });

    const reset = () => {
        setFormObj({
            AadharNo: aadharNumber,
            MobileNumber: Mobile,
            FingerPrint: '',
            IsAEPS: false
        });
    };

    const validationSchema = Yup.object({
        AadharNo: Yup.string()
            .length(12, 'Must be 12 digit')
            .required(PLEASE_PROVIDE_VALID + 'aadhaar number'),

        MobileNumber: Yup.string()
            .length(10, 'Must be 10 digit')
            .required(PLEASE_PROVIDE_VALID + 'number')
    });

    const SubmitHandle = async (values, { resetForm }) => {
        setIsError(false);
        setResponseMessage('');
        setLoadingOpen(true);

        const { status, xmldata } = await GetFingerPrint('');

        if (status === false) {
            alert(xmldata);
            return;
        }
        let fingerPrintXML = xmldata;
        let SelectedOperatorID = 0;
        if (values.IsAEPS) {
            SelectedOperatorID = AEPS_OPERATOR_ID;
        }
        var request = {
            FingerPrint: fingerPrintXML,
            AadharNo: values.AadharNo,
            MobileNumber: values.MobileNumber,
            OperatorID: SelectedOperatorID,
            Latitude: latitude,
            Longitude: longitude
        };
        var requestObj = JSON.stringify(request);
        var response = await TWOFACTORAUTHENTICATION(requestObj);
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();
        setSeverity('success');

        if (!response.status) {
            var data = JSON.parse(response.data);
            setIsError(true);
            setSeverity('error');
            setResponseMessage(data.Message);
            setStatus('FAILURE');
            setMessage(data.Message);
            setIsAlertErrorOpen(true);
            reset();
            return;
        }
        history.push('/OCAEPS');
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'ID',
            srno: true
        });

        columns.push({
            label: 'Date',
            name: 'DOC'
        });
        columns.push({
            label: 'Operator',
            name: 'Operator'
        });
        columns.push({
            label: 'Status',
            name: 'Status',
            customStatus: true
        });

        setMainColumns(columns);
    };

    useEffect(() => {
        Select();
        fetchConsumerNumberFontSize();
    }, []);

    const Select = async () => {
        var request = {
            ProviderName: ONECLICK
        };
        var requestObj = JSON.stringify(request);
        createColumns();
        setTransactions([]);
        setLoadingOpen(true);
        var response = await TRANSACTION_REPORT(requestObj);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();
        if (!response.status) return;
        var data = JSON.parse(response.data);
        setTransactions(data);
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObj}
                validationSchema={validationSchema}
                onSubmit={SubmitHandle}
                resetForm={formObj}
            >
                {({ setFieldValue, handleSubmit }) => {
                    return (
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <Grid container>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                        >
                                            <Paper
                                                className={classes.PaperStyle}
                                            >
                                                <h2 className={classes.PaperHead_h2}>
                                                    2FA : Latitude: {latitude}, Longitude:{longitude}
                                                </h2>

                                                <Grid container>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        lg={12}
                                                    >
                                                        <MaterialNumberField
                                                            font_size={
                                                                consumerNumberFontSize
                                                            }
                                                            label="Aadhar No"
                                                            name="AadharNo"
                                                            placeholder="Aadhar No"
                                                            title="Aadhar No"
                                                            length="12"
                                                            typed_length={1}
                                                        />
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        lg={12}
                                                    >
                                                        <MaterialNumberField
                                                            font_size={
                                                                consumerNumberFontSize
                                                            }
                                                            label="Mobile Number"
                                                            name="MobileNumber"
                                                            icon="mobile"
                                                            placeholder="Mobile Number"
                                                            title="Mobile Number"
                                                            length="10"
                                                            typed_length={1}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                            <Grid className={classes.footerGrid}>
                                                <Box
                                                    className={classes.flexReverse}
                                                >
                                                    <div
                                                        className={
                                                            classes.SubmitWrapper
                                                        }
                                                    >
                                                        <div className="container">
                                                            <div className="row">
                                                                <div className="col-md-5">
                                                                    <SecondaryButton
                                                                        disabled={
                                                                            loadingOpen
                                                                        }
                                                                        endIcon={
                                                                            <ResetIcon />
                                                                        }
                                                                        title="Reset"
                                                                        onClick={() => {
                                                                            reset();
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="col-md-7">
                                                                    <PrimaryButton
                                                                        title="Proceed"
                                                                        disabled={
                                                                            loadingOpen
                                                                        }
                                                                        endIcon={
                                                                            <RechargeIcon />
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </Form>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={8}
                                lg={8}
                                className="last Authentication"
                            >
                                <ReactTable
                                    data={transactions}
                                    columns={mainColumns}
                                    headerToolbar={false}
                                    footerToolbar={false}
                                />
                            </Grid>
                        </Grid>
                    );
                }}
            </Formik>

            {isAlertErrorOpen ? (
                <FailTransactionResponse
                    isOpen={isAlertErrorOpen}
                    title={status}
                    Message={Message}
                    OkButtonClick={(request) => {
                        setIsAlertErrorOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
